module.exports = "//static.hsappstatic.net/salesImages/static-1.403/onboarding/extension-illustration-2.png"